import {Divider, Heading, HStack, Spacer, Text, VStack} from '@chakra-ui/react'
import {useParams} from 'react-router-dom'
import {PremiumAvatar} from '../Common/PremiumAvatar'
import {$, k} from '../../i18n/localization'
import {NAVBAR_HEIGHT_WITH_PADDING} from '../../styles/theme'
import Store from '../../utils/Store'
import {BoxDetail} from '../Common/BoxDetail'
import DancerCalculatedResults from '../Dancer/DancerCalculatedResults'
import DancerInterested from '../Dancer/DancerInterested'
import DancerSelection from '../Dancer/DancerSelection'

const SchoolDetails = () => {
  const {id} = useParams()
  const schoolObs = Store.schools.find(s => s.id.toString() === id)
  if (!schoolObs) return null
  const school = schoolObs.peek()

  return (
    <VStack alignItems='start' spacing={5}>
      <HStack w='full'>
        <PremiumAvatar
          src={school.picture}
          size="2xl"
          variant="school"
          borderRadius="2xl"
        />
        <VStack flex={1} alignSelf='stretch'>
          <BoxDetail h='full'>
            <Text>{$(k.name)}</Text>
            <Heading>{school.name}</Heading>
            {school.description && (
              <Text mt={2} color='gray.600' fontSize='sm'>
                {school.description}
              </Text>
            )}
          </BoxDetail>
          <HStack w='full'>
            <BoxDetail>
              <Text>{$(k.country)}</Text>
              <Heading as='h4'>{school.country}</Heading>
            </BoxDetail>
            <BoxDetail>
              <Text>{$(k.minimumAge)}</Text>
              <Heading as='h4'>{school.minAge}</Heading>
            </BoxDetail>
            <BoxDetail>
              <Text>Languages</Text>
              <Heading as='h4'>{school.languages?.join(', ')}</Heading>
            </BoxDetail>
          </HStack>
        </VStack>
      </HStack>
      <VStack
        spacing={5}
        w='full'
        maxH={`calc(100vh - ${NAVBAR_HEIGHT_WITH_PADDING}px - 315px)`}
        overflowY='scroll'>
        <Divider />
        <DancerCalculatedResults school={schoolObs} />
        <DancerSelection school={schoolObs} />
        <Divider />
        <DancerInterested school={schoolObs} />
        <Spacer />
      </VStack>
    </VStack>
  )
}

export default SchoolDetails
